import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Drlogin from "./pages/Drlogin";
import Drsignup from "./pages/Drsignup";
import UserDashboard from "./pages/UserDashboard";
import FreeMCQ from "./pages/FreeMCQ";
import FreeMCQExam from "./pages/FreeMCQExam";
import Subscription from "./pages/Subscription";
import PremiumMCQ from "./pages/PremiumMCQ";
import PremiumPapers from "./pages/PremiumPapers";

import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ShowFreeResult from "./pages/ShowFreeResult";
import PremiumMCQStart from "./pages/PremiumMCQStart";
import ShowPremiumResult from "./pages/ShowPremiumResult";

import PrimePaperCategory from "./pages/PrimePaperCategory";
import PrimePapers from "./pages/PrimePapers";
import PrimePaperStart from "./pages/PrimePaperStart";
import ShowPrimePaperResult from "./pages/ShowPrimePaperResult";

import "./App.css";


function App() {
  return (
    <BrowserRouter >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/Drlogin" element={<Drlogin />} />
        <Route path="/Drsignup" element={<Drsignup />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/prime-paper-category" element={ < PrimePaperCategory/> } />
        <Route path="/prime-papers/:category" element={ <PrimePapers /> } />
      
<Route
    path="/premium-paper/result/:historyId"
    element={
        <ShowPrimePaperResult />
    }
/>


        <Route
    path="/premium-paper/start/:paperId"
    element={<PrimePaperStart />}
/>
        <Route
    path="/premium-mcq/result/:paperId"
    element={<ShowPremiumResult />}
/>
        <Route
    path="/premium-mcq/start/:paperId"
    element={
        <PremiumMCQStart />
    }
/>
        <Route
    path="/show-free-result/:paperId"
    element={<ShowFreeResult />}
/>
        <Route
    path="/terms-and-conditions"
    element={<TermsAndConditions />}
/>
        <Route
          path="/premium-mcq"
          element={<PremiumMCQ />}
      />
              <Route
          path="/subscription"
          element={<Subscription />}
      />
              <Route
        path="/free-mcq"
        element={<FreeMCQ />}
      />
      <Route
          path="/free-mcq/exam/:paperId"
          element={<FreeMCQExam />}
      />
      <Route
          path="/premium-mcq/subject/:subject"
          element={<PremiumPapers />}
      />
      <Route path="/contact" element={<Contact />} />

      </Routes>

    </BrowserRouter>
  );
}

export default App; 